import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

import { KnowledgeBaseClient } from '@medindex-webapi';
import { BacktopComponent } from '@shared/components/backtop/backtop.component';
import { BreadcrumbModule } from '@shared/modules/breadcrumb/breadcrumb.module';
import { SkeletonModule } from '@shared/modules/skeleton/skeleton.module';
import { PreventDoubleclickDirective } from '@shared/directives/prevent-doubleclick.directive';
import { OverscrollYDirective } from '@shared/directives/overscroll/y-overscroll';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { MobileFiltersModalModule } from '@shared/modules/mobile-filters-modal/mobile-filters-modal.module';
import { ShowMoreDirective } from '@shared/directives/show-more.directive';
import { FloatingButtonComponent } from '@shared/components/floating-button/floating-button.component';
import { MobileSearchModalComponent } from './components/mobile-search-modal/mobile-search-modal.component';
import { DatesBarComponent } from '../publications/components/dates-bar/dates-bar.component';
import { SearchBarComponent } from '../publications/components/search-bar/search-bar.component';
import { TagsComponent } from '../publications/components/tags/tags.component';
import { HelixBookRoutingModule } from './helix-book-routing.module';
import { SearchPanelComponent } from './components/search-panel/search-panel.component';
import { ListComponent } from './components/list/list.component';
import { ListItemComponent } from './components/list-item/list-item.component';
import { HelixBookComponent } from './pages/helix-book/helix-book.component';
import { DictComponent } from './pages/dict/dict.component';
import { ItemComponent } from './pages/item/item.component';
import { AnchorListComponent } from './components/anchor-list/anchor-list.component';
import { KbInfoPipe } from './pipes/kb-info.pipe';
import { PriceComponent } from './components/price/price.component';
import { AnalyseTypeCheckPipe } from './pipes/analyse-type-check.pipe';
import { ExampleFileComponent } from './components/example-file/example-file.component';
import { HelixBookFormService } from './services/helix-book-form.service';
import { SearchComponent } from './components/search/search.component';
import { ButtonKeyboardComponent } from './components/button-keyboard/button-keyboard.component';

@NgModule({
  declarations: [
    HelixBookComponent,
    SearchPanelComponent,
    ListItemComponent,
    MobileSearchModalComponent,
    ListComponent,
    DictComponent,
    ItemComponent,
    AnchorListComponent,
    KbInfoPipe,
    PriceComponent,
    AnalyseTypeCheckPipe,
    ExampleFileComponent,
    SearchComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HelixBookRoutingModule,
    BreadcrumbModule,
    NzSelectModule,
    NzTabsModule,
    ButtonKeyboardComponent,
    MobileFiltersModalModule,
    ShowMoreDirective,
    FloatingButtonComponent,
    DatesBarComponent,
    SearchBarComponent,
    TagsComponent,
    NzAnchorModule,
    BacktopComponent,
    SkeletonModule,
    NzResultModule,
    NzSkeletonModule,
    PreventDoubleclickDirective,
    OverscrollYDirective,
    SafeHtmlPipe,
  ],
  providers: [KnowledgeBaseClient, HelixBookFormService],
})
export class HelixBookModule {}
